import { useModel, useRoute } from "@bcm-dev/bcms-vite";
import { useMultiPay } from "compid/workflows/MultiPay";
import { Bill, Payment } from "model/";

import ButtonContainer from 'compid/shared/containers/ButtonContainer';
import BillerView from "compid/shared/views/BillerView";
import UIButton from "compid/ui/UIButton";
import UICheckbox from 'compid/ui/UICheckbox';
import { SVGAsset } from "res";

export default function NewPaymentBillerView(props) {
    const { payments } = useModel();
    const { toggleAdd, state, submit } = useMultiPay();
    const navigate = useRoute();

    const getLastPayment = billerID => Payment.initByID(
        payments.reduce((lastPayment, payment) => payment.paymentTo === billerID && ((parseInt(payment.paymentDate) > parseInt(lastPayment.paymentDate)) || lastPayment.paymentDate === undefined)
            ? payment
            : lastPayment, {}).paymentID);

    const bills = Bill.initAll().reduce((result, bill) => {
        const isIncluded = state.includes(bill.id);
        const shouldDisable = state.length > 0;

        const disabledClass = shouldDisable ? "disabled-gray" : "";
        const billerIsAdded = bill.biller.addType !== "quick_add" && bill.biller.addType !== "verification_add";

        const showPayIcon = bill.biller.paymentType === "instantPayment" || bill.biller.paymentType === "withinMinutes";

        const onClick = evt => !shouldDisable
            ? navigate(`/makeAPayment/${ bill.id }`)
            : undefined;
            const group = props.group;
       
            const billerInGroup = (biller)=>{
               if (group === "default"){
                    return biller.billerGroup === undefined;
                }else{
                   if( biller.billerGroup !== undefined){
                    return group !== undefined ? biller.billerGroup.id === group:true; 
                   }else{
                    return group == undefined ;
                   }
                    
                }
                    return false;
            }     
        return bill.status.toLowerCase() !== "due" && !getLastPayment(bill.biller.id) && billerIsAdded && billerInGroup(bill.biller)
            ? result.concat(
                <BillerView 
                    key={ "biller_" + bill.biller.id }
                    biller={ bill.biller }
                    className={ isIncluded ? "selected-biller-view paid-upcoming-biller-view" : "paid-upcoming-biller-view" }
                    checkbox={ <UICheckbox value={ isIncluded } onChange={ value => toggleAdd(value, bill.id) } /> }
                    dataPoint={ `Pay_Bills_Biller_${ bill.biller.id }` }
                    buttons={
                        <>
                            { !isIncluded && 
                                <ButtonContainer className="set-width">
                                    <UIButton className={ `secondary-button ${ disabledClass }` }
                                    dataPoint={ `My_Billers_Button_Biller_${ bill.biller.id }` } onClick={ onClick }>Pay{ showPayIcon && <SVGAsset id="ZapIcon" className="zap-icon" /> }</UIButton>
                                </ButtonContainer> }

                            { isIncluded && 
                                <ButtonContainer className="set-width">
                                    <UIButton 
                                        className="primary-button multipay-btn"
                                        dataPoint={ `My_Billers_Button_Biller_${ bill.biller.id }` } 
                                        onClick={ submit }>Pay { state.length } biller{ state.length > 1 ? "s" : "" }</UIButton>
                                </ButtonContainer> }
                        </>
                    }
                    upsell={ props.getUpSale(bill) }
                />
            )
            : result;
    }, []);    

    return (
        <div className="paid-upcoming-biller-view-container">
            { bills }
        </div>
    );
}